import { BarcodeFormat } from '@zxing/library';

export const supportedBarcodeFormats: BarcodeFormat[] = <BarcodeFormat[]>(
    Object.values(BarcodeFormat).filter((v) => !isNaN(Number(v)))
);
